<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "ReturnList",
    components: {
        RawData
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        groupedItems: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            default: "pending"
        }
    },
    data() {
        return {
            search: "",
            currentPage: 1,
            perPage: 10,
            sortBy: "transactionDate",
            sortDesc: true,
        }
    },
    computed: {
        filtered() {
            if (!this.search) {
                return this.groupedItems;
            }
            return this.groupedItems.filter(item => item.filterKey.toLowerCase().includes(this.search.toLowerCase()));
        },
        rows() {
            return this.filtered.length;
        },
        fields() {
            return [
                { key: "id", label: "Return Request" },
            ];
        },
    },
    methods: {
        getName(officer) {
            if (!officer) return "N/A";
            return `${officer.lastName}, ${officer.firstName}`;
        },
        approveRequest(item) {
            this.$emit("approve", item);
        },
        printReturnSlip(item) {
            this.$emit("print-slip", item);
        },
        updateItem(item) {
            this.$emit("update", item);
        },
        deleteItem(item) {
            this.$emit("delete", item);
        },
        viewItems(item) {
            this.$emit("view", item);
        }
    }
}
</script>
<template>
  <section>
    <div class="mb-2 d-flex justify-content-between align-items-center">
        <div class="w-300px">
            <input type="text" class="form-control" placeholder="Search Property..." v-model="search">
        </div>
        <p class="mb-0">Total Properties: <span class="text-warning">{{ formatNumber(rows) }}</span></p>
    </div>
    <b-table
        class="datatables target-table"
        :items="filtered"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :busy="loading"
        bordered
        outlined
        striped
        show-empty
        >
        <template #empty>
            <div class="text-center">
                <div v-if="search != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching your request
                </div>
                <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                </div>
            </div>
        </template>
        <template #table-busy>
            <div class="text-center">
                <b-spinner></b-spinner>
            </div>
        </template>
        <template #cell(id)="row">
            <div class="d-flex justify-content-between position-relative">
                <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" />
                <div v-if="row.item.accountableOfficer">
                    <div class="text-white font-weight-bold">{{ getName(row.item.accountableOfficer) }}</div>
                    <div>
                        <ul class="m-0 ps-4">
                        <li>
                            {{ row.item.accountableOfficer.campus }}
                            <ul class="m-0 ps-2">
                            <li>
                                {{ row.item.accountableOfficer.office }}
                                <ul class="m-0 ps-0" style="list-style-type: '→'">
                                <li>
                                    <span class="badge bg-success font-size-12 ms-1" style="white-space:normal !important;">
                                        {{ row.item.accountableOfficer.position }}
                                    </span>
                                </li>
                                </ul>
                            </li>
                            </ul>
                        </li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    <span class="text-muted">N/A</span>
                </div>
                <div
                    class="d-flex justify-content-between"
                    style="width: 45%;"
                >
                    <div>
                        <b>Transaction Date:</b>
                        <div class="mb-1">{{ row.item.transactionDate ? formatDate(new Date(row.item.transactionDate)) : "N/A" }}</div>
                        <a 
                            href="javascript:void(0);" 
                            class="d-flex align-items-center hover-underline"
                            @click="viewItems(row.item)"
                        >
                            View Items <i class="bx bx-chevron-right"></i>
                        </a>
                    </div>
                    <div>
                        <div class="gap-2 d-flex align-items-center">
                            <a
                                title="Print Return Request"
                                href="javascript:void(0);"
                                @click="printReturnSlip(row.item)"
                            >
                                <i class="bx bx-printer fs-4"></i>
                            </a>
                            <a
                                title="Delete"
                                href="javascript:void(0);"
                                class="text-danger"
                                @click="deleteItem(row.item)"
                            >
                                <i class="bx bx-trash fs-4"></i>
                            </a>
                            <template v-if="type == 'pending'">
                                <a
                                    title="Update"
                                    href="javascript:void(0);"
                                    class="text-info"
                                    @click="updateItem(row.item)"
                                >
                                    <i class="bx bx-edit-alt fs-4"></i>
                                </a>
                                <a
                                    title="Approve Return Request"
                                    href="javascript:void(0);"
                                    class="text-success"
                                    @click="approveRequest(row.item)"
                                >
                                    <i class="bx bx-check-circle fs-3"></i>
                                </a>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </b-table>
    <div class="dataTables_paginate paging_simple_numbers float-end">
        <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
            ></b-pagination>
        </ul>
    </div>
  </section>
</template>